import { styled } from "@material-ui/core";
import { XSMALL_HEIGHT_BREAKPOINT_MQ } from "../../hooks/use-xsmall-height-mq";

export const BackgroundVideoWrapper = styled("div")(({ theme }) => ({
  position: "relative",
  overflow: "hidden",
  width: "100%",
  height: "100%",
  backgroundColor: theme.palette.common.black,
  minHeight: `min(max(calc(100vh - var(--header-height)), 700px), 1200px)`, // Use min & max to not overstretch the hero
  display: "flex",
  justifyContent: "flex-end",
  flexDirection: "column",
  alignItems: "center",
  paddingBottom: theme.spacing(2),
  [theme.breakpoints.down("sm")]: {
    minHeight: `min(max(calc(var(--initial-100vh, 100vh) - var(--header-height)), 400px), 900px)`,
    paddingBottom: theme.spacing(2),
    "&.express-panel": {
      minHeight: `min(max(calc(var(--initial-100vh, 100vh) - var(--header-height) - 50px), 400px), 900px)`
    }
  },
  [theme.breakpoints.up("xl")]: {
    paddingBottom: theme.spacing(4)
  },
  "& video": {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    zIndex: 0
  }
}));

export const CustomHeading = styled("h1")(({ theme }) => ({
  fontFamily: `Reckless`,
  fontSize: "5rem",
  lineHeight: "5.6rem",
  letterSpacing: "-1px",
  color: theme.palette.text.primary,
  textAlign: "center",
  fontWeight: 500,
  "& .yellow": {
    color: theme.palette.primary.main
  },
  "& .bold": {
    fontWeight: 600,
    position: "relative",
    zIndex: 1,
    display: "inline-block",
    "&::after": {
      content: "' '",
      display: "block",
      background: theme.palette.common.white,
      width: "100%",
      height: "5px",
      borderRadius: "1px",
      zIndex: -1,
      marginTop: "-2px"
    }
  },
  [theme.breakpoints.down("xs")]: {
    userSelect: "none",
    fontSize: "3rem",
    lineHeight: "3.2rem",
    letterSpacing: "0px",
    maxWidth: "290px"
  },

  [theme.breakpoints.up("xl")]: {
    userSelect: "none",
    fontSize: "6rem",
    lineHeight: "6.6rem"
  },
  [XSMALL_HEIGHT_BREAKPOINT_MQ]: {
    fontSize: "2.8rem",
    lineHeight: "3rem"
  }
}));

export const VideoGradient = styled("div")(({ theme }) => ({
  width: "100%",
  height: "80px",
  position: "absolute",
  left: 0,
  bottom: "-10px",
  background: "linear-gradient(rgb(254 196 0 / 0%) 0%, rgb(255, 187, 0) 100%)",
  [theme.breakpoints.down("xs")]: {
    height: "60px"
  }
}));
